document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('age-overlay');
  const confirm = document.getElementById('age-confirm');
  const back = document.getElementById('age-back');

  if (!overlay) return;

  if (localStorage.getItem('ageVerified') === 'true') {
    return;
  }

  overlay.classList.add('is-visible');

  confirm.addEventListener('click', () => {
    localStorage.setItem('ageVerified', 'true');
    overlay.classList.remove('is-visible');
  });

  back.addEventListener('click', () => {
    if (document.referrer) {
      history.back();
    } else {
      window.location.href = '/';
    }
  });
});